<template>
  <div>
    <Head :title="__('user.create')"/>
    <h1 class="h1">
      <Link class="text-primary-400 hover:text-primary-600" href="/users">{{ __('user.singular') }}</Link>
      <span class="text-primary-400 font-medium">/ {{ __('general.create') }}</span>
    </h1>

    <alert v-if="showSuccess" type="success">{{ showSuccess }}</alert>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
      <div class="column">

        <h2 class="text-xl font-medium mb-2">Dateneingabe:</h2>

        <div class="card">

          <div class="my-10">
            <div class="flex gap-4">
              <div class="">
                <label for="text_answer" class="block mb-2 text-sm font-medium text-gray-900">
                  Campus User?
                </label>
                <label for="campus" class="inline-flex relative items-center cursor-pointer">
                  <input v-model="is_campus" id="campus" type="checkbox" class="sr-only peer">
                  <div :class="toggleCampusClass"
                       class=" w-11 h-6 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"
                  ></div>
                  <span class="ml-3 text-sm font-medium text-gray-900">{{ __('general.' + is_campus) }}</span>
                </label>
              </div>
              <div>
                <label for="text_answer" class="block mb-2 text-sm font-medium text-gray-900">
                  BV Mitglied?
                </label>
                <label for="member" class="inline-flex relative items-center cursor-pointer">
                  <input v-model="is_member" type="checkbox" id="member" class="sr-only peer">
                  <div :class="toggleMemberClass"
                       class=" w-11 h-6 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"
                  ></div>
                  <span class="ml-3 text-sm font-medium text-gray-900">{{ __('general.' + is_member) }}</span>
                </label>
              </div>
            </div>

          </div>

          <div class="flex flex-col justify-content-end">

            <label for="possible_users" class="block mb-2 text-sm font-medium text-gray-900">
              Füge hier Deine Zwischenablage ein
            </label>
            <textarea id="possible_users" v-model="data" class="textarea" rows="18"
                      :placeholder="__('question.your_answer')" @input="massAssign"
            ></textarea>
            <span v-if="
            isLoading"
            >{{ __('question.you_are_typing') }}</span>
          </div>


          <loading-button v-if="possible_users" :loading="isLoading" class="mt-4 btn w-auto inline-flex btn-primary"
                          @click="massupload" type="submit"
          >
            {{ __('general.save') }}
          </loading-button>

        </div>

      </div>
      <div class="column">
        <div v-if="possible_users && possible_users.length > 0" class="">
          <h2 class="text-xl font-medium mb-2">Erkannte E-Mails:</h2>
          <div class="flex gap-2">
            <button @click="removeExisting" class="btn btn-primary btn-sm mb-3">Bestehende entfernen</button>
            <button @click="checkEmails" class="btn btn-secondary btn-sm mb-3">E-Mails prüfen</button>
          </div>
          <ul>
            <li v-for="( possibleUser, index ) in possible_users" :key="index" class="card flex justify-between mb-2">
              <div class="">{{ possibleUser.email }}
                <small>
                  <span v-if="possibleUser.fresh" class="text-yellow-500"><i class="fa fa-question-circle"></i> Nicht überprüft</span>
                  <span v-else-if="possibleUser.exists" class="text-red-500"><i class="fa fa-times"></i> Bestehendes Konto</span>
                  <span v-else class="text-success-500"><i class="fa fa-check"></i> Neues Konto</span>
                </small>
              </div>
              <button class="btn-danger--sm" @click="removeUser(index)"><i class="fa fa-trash"></i></button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {massupload, checkEmails} from '../../api/UserApi'

import {Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
// import FileInput from '@/Shared/FileInput'
// import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Alert from '../../Shared/Components/Alert'

export default {
  components: {
    // FileInput,
    // Head,
    Alert,
    Link,
    LoadingButton,
    // SelectInput,
    // TextInput,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      isLoading: false,
      data: null,
      is_member: false,
      is_campus: false,
      possible_users: [],
      showSuccess: null,
      // form: this.$inertia.form({
      // }),
    }
  },

  computed: {
    toggleMemberClass: function () {
      return (this.is_member) ? 'bg-secondary-500' : 'bg-gray-200'
    },
    toggleCampusClass: function () {
      return (this.is_campus) ? 'bg-secondary-500' : 'bg-gray-200'
    },
  },

  methods: {
    store: function () {

    },

    toggleUserType: function () {

    },

    massAssign: async function () {
      let _this = this
      let dataArray = this.data.split('\n')
      let possibleUsers = dataArray.filter(possibleEmail => {
        return _this.validateEmail(possibleEmail)
      })
      possibleUsers = possibleUsers.map(possibleUser => {
        return {
          email: possibleUser,
          exists: false,
          fresh: true,
        }
      })
      this.possible_users = [...new Set(possibleUsers)]
    },

    checkEmails: async function () {
      var possibleUsers = await checkEmails(this.possible_users)
      // possibleUsers =  Object.values(possibleUsers)
      this.possible_users = [...new Set(possibleUsers)]
    },

    validateEmail: function (email) {
      return email.match(
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      )
    },

    removeExisting: function () {
      let existing = this.possible_users.filter(user => {
        return !user.exists
      })
      this.possible_users = [...new Set(existing)]
    },

    massupload: async function () {
      let amount = this.possible_users.length
      if (confirm(`Du bist dabei, diese ${amount} E-Mails als User anzulegen und Ihnen eine Willkommens-E-Mail zu schreiben. Willst Du fortfahren (bereits vorhandene E-Mails werden nicht neu angelegt)?`)) {
        let data = {
          emails: this.possible_users,
          is_member: this.is_member,
          is_campus: this.is_campus,
        }
        let response = await massupload(data)
        this.showSuccess = response.msg
        this.possible_users = []
        this.data = null
      }

    },

    removeUser: function (index) {
      console.log(index)
      this.possible_users.splice(index, 1)
    },
  },
}
</script>
